import {useMutation} from "@apollo/client";

import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
import {GQL_ACCOUNTUSER_SET_ACTIVE_STATE, GQL_ACCOUNTUSERS_QUERY} from "@/lib/queries/accounts.ts";
import {AccountUser} from "@/lib/types/accounts.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";

export interface UserActionToggleActiveProps {
  user: AccountUser;
  show: boolean;
  setShow: (show: boolean) => void;
}

export const UserActionToggleActive = ({user, show, setShow}: UserActionToggleActiveProps) => {
  const [setUserActiveState, {data, reset, loading}] = useMutation<GraphQLResponse<null>>(
    GQL_ACCOUNTUSER_SET_ACTIVE_STATE,
    {
      refetchQueries: [GQL_ACCOUNTUSERS_QUERY],
    }
  );

  const handleSubmit = async () => {
    const response = await setUserActiveState({
      variables: {
        id: user.id,
        is_active: !user.is_active,
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
    }
  };

  const serverErrors = data?.response?.status === ResponseStatus.ERROR ? data?.response?.message.__all__ : [];

  const newStateAction = !user.is_active ? "Activate" : "Deactivate";

  return (
    <ActionDialog
      show={show}
      loading={loading}
      title={serverErrors?.length > 0 ? "Unable to set user active state" : `${newStateAction} User`}
      onConfirm={handleSubmit}
      disableConfirmButton={serverErrors?.length > 0}
      cancelBtnText={serverErrors?.length > 0 ? "Close" : "Cancel"}
      confirmBtnText="OK"
      onCancel={() => {
        setShow(false);
        reset();
      }}
    >
      {serverErrors?.length > 0
        ? serverErrors[0]
        : `Are you sure you want to ${newStateAction.toLowerCase()} User "${user.first_name} ${user.last_name}"?`}
    </ActionDialog>
  );
};
